import { useQuery } from '@tanstack/react-query';
import { movimientosByOtId } from '../api/common';

export const OT_MOVIMIENTOS_KEY = (otId) => ['movimientosOt', otId];

export function useOtMovimientos(otId) {
  return useQuery({
    queryKey: OT_MOVIMIENTOS_KEY(otId),
    queryFn: async () => {
      const res = await movimientosByOtId(otId);
      const today = new Date();
      const todos = res.status === 200 && Array.isArray(res.data?.data) ? res.data.data : [];
      const activos = todos.filter(m => {
        if (m.status !== 'open') return false;
        if (m.dueDate && new Date(m.dueDate) < today) return false;
        return true;
      });
      return {
        activos,
        patronIds: new Set(activos.map(m => m.patronId?._id || m.patronId).filter(Boolean)),
      };
    },
    staleTime: 60 * 1000,
    enabled: !!otId,
  });
}
